'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  andUp: '& Up'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/dist-es5-module/src/widgets/star-rating/defaultLabels.js
// module id = 71S/
// module chunks = 0